import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Redirect } from "react-router-dom";

export default class Logout extends React.Component<RouteComponentProps<{}>, {}> {
    public constructor(props: RouteComponentProps<{}>) {
        super(props);

        localStorage.removeItem("access_token");
    }

    public render() {
        return <Redirect to="/logout" />;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/account/Logout.tsx